<template>
  <div class="baniere pt-6 md:pb-24 pb-10">
    <popupProject
      :want-to-make-offer="activeProjet"
      @oga="retourProjet"
    />
    <div class="flex justify-end md:pt-0 pt-20">
      <div
        class="md:w-1/3 w-full flex items-center justify-end"
        data-aos="fade-left"
        data-aos-duration="1000"
      >
        <div
          class="titre1 mr-4 cursor-pointer"
          @click="openProjet"
        >
          Demander une démo
        </div>
        <svg-icon
          name="ic_arrow"
          class="md:h-8 h-4 cursor-pointer"
          original
          @click="openProjet"
        />
      </div>
    </div>

    <div class="md:flex mt-20">
      <div class="bloc1 pt-4">
        <div class="md:w-full w-2/3">
          <divider
            :height="diviserHeight"
            :color="diviserColor"
            data-aos="fade-right"
            data-aos-duration="1000"
          />
        </div>
        <div
          class="titre w-full mt-5"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Un ensemble d'outils efficaces pour servir les clients de votre banque
        </div>
      </div>

      <div class="bloc2 md:pl-20 md:mt-0 mt-8">
        <div
          class="title3"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          Que vous démarriez votre activité de crédit ou que vous soyez déjà un fournisseur de prêts établi, le système
          de gestion numérique des crédits de 41DEVS vous offre un ensemble d'outils efficaces pour servir les clients
          de votre banque allant des particuliers aux grandes entreprises. Améliorer votre portefeuille de produits n'a
          jamais été aussi facile - vous pouvez facilement configurer un nouveau produit, effectuer les tests nécessaires
          et profiter des avantages du lancement de nouveaux produits en quelques jours au lieu de plusieurs mois.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/helper/divider'
import popupProject from '@/components/popup/popupProject'

export default {
  name: 'Index',
  components: {
    divider,
    popupProject
  },
  props: {
  },
  data () {
    return {
      diviserColor: '#9FB4FE',
      diviserHeight: '5px',
      activeProjet: false
    }
  },
  created () {
  },
  methods: {
    openProjet () {
      this.activeProjet = true
    },
    retourProjet (answer) {
      this.activeProjet = answer
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $white;
   position: relative;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }
  .bloc1{
    width: 32%;
  }
  .bloc2{
    width: 68%;
    font-weight: bold;
    font-size: 24px;
    line-height: 160%;
  }

  .titre{
    font-weight: 800;
    font-size: 40px;
    line-height: 150%;
    letter-spacing: 0.01em;
    color: $black
  }
  .titre1{
    font-weight: 800;
    font-size: 24px;
    line-height: 150%;
    letter-spacing: 0.01em;
    color: $dev_green;
  }
  .title3{
    font-weight: 400;
    color: $black;
  }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
    }
    .titre{
      font-size: 28px;
    }
    .bloc1{
      width: 100%;
    }
    .bloc2{
      width: 100%;
      font-size: 18px;
    }
    .titre1{
      font-size: 20px;
    }
    .title3{
      font-size: 18px;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .titre{
      font-size: 30px;
    }
    .title3{
      font-size: 22px;
    }
    .titre1{
      font-size: 20px;
    }

    .blocc {
      padding: 30px;
    }
  }
</style>
